import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, useColorModeValue } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';

/**
 * Breadcrumbs component for navigation
 *
 * Usage:
 * <Breadcrumbs
 *   items={[
 *     { label: 'Home', path: '/' },
 *     { label: 'Polls', path: '/pollsPage' },
 *     { label: 'Manage Questions' }  // Current page (no path)
 *   ]}
 * />
 */
function Breadcrumbs({ items = [] }) {
  const linkColor = useColorModeValue('theme.teal', 'theme.teal');
  const textColor = useColorModeValue('theme.black', 'theme.white');

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Breadcrumb
      spacing="8px"
      separator={<ChevronRightIcon color="theme.mediumGray" />}
      mb={4}
      fontSize="sm"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <BreadcrumbItem key={index} isCurrentPage={isLast}>
            {isLast || !item.path ? (
              <BreadcrumbLink color={textColor} fontWeight="semibold">
                {item.label}
              </BreadcrumbLink>
            ) : (
              <BreadcrumbLink
                as={ReactRouterLink}
                to={item.path}
                color={linkColor}
                _hover={{ textDecoration: 'underline' }}
              >
                {item.label}
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
}

export default Breadcrumbs;
